import { render, staticRenderFns } from "./LessonMaterialBlock.vue?vue&type=template&id=1f211bea&scoped=true&"
import script from "./LessonMaterialBlock.vue?vue&type=script&lang=js&"
export * from "./LessonMaterialBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f211bea",
  null
  
)

export default component.exports